<template>
    <div class="media-services-wrapper">
        <div class="container" v-show="!isLoding">
            <template v-if="flag == -1 || flag == 1">
                <div class="box">
                    <img src="../../assets/img/3.2.0/app_accress.png" alt="">
                    <p class="info">如果您是媒体机构，希望获取新闻素材，您可点击下方“申请访问”，提交访问申请</p>
                    <Button @click="apply" type="primary">申请访问</button>
                </div>
            </template>
            <template v-if="flag == 0">
                <div class="box">
                    <img src="../../assets/img/3.2.0/hk-shared.png" alt="">
                    <p class="info-0">提交成功</p>
                    <p class="info-1">系统审核中</p>
                    <p class="info-2">审核成功后，将自动进入媒体服务板块</p>
                    <!-- <Button @click="resetSubmit" type="primary">重新提交</button> -->
                </div>
            </template>
            <template v-if="flag == 2">
                <div class="box">
                    <img src="../../assets/img/3.2.0/hk-shared.png" alt="">
                    <p class="info-0">提交成功</p>
                    <p class="info-1" style="color: red;">审核不通过</p>
                    <p class="info-2">不通过原因:{{ reason }}</p>
                    <Button @click="resetSubmit" type="primary">重新提交</button>
                </div>
            </template>
            <template v-if="flag == 3 || flag == 4">
                <div class="box">
                    <img src="../../assets/img/3.2.0/warn.png" alt="">
                    <p class="info-1" style="color: red;">访问有效期已过</p>
                    <p class="info-2">您的访问有效期已过，请重新提交访问申请</p>
                    <Button @click="resetSubmit" type="primary">重新提交</button>
                </div>
            </template>

            <template v-if="flag == 5">
                <div class="box">
                    <img src="../../assets/img/3.2.0/app_accress.png" alt="">
                    <p class="info">如果您是媒体机构，希望获取新闻素材，您可点击下方“申请访问”，提交访问申请</p>
                    <Button @click="apply" type="primary">申请访问</button>
                </div>
            </template>
        </div>
        <Login ref="login" />
    </div>
</template>
<script>
import { mapState } from 'vuex';
import MaskPopup from '../../components/MaskPopup.vue';
import Login from '../../components/Login.vue';
import { Button } from 'element-ui';
export default {
    name: 'About',
    data() {
        return {
            navIndex: 1,
            flag: -1,
            reason: '',
            isLogin: true,
            isLoding : true

        }
    },
    components: {
        MaskPopup,
        Login,
        Button
    },
    created() {
        this.flag = this.userInfo.flag || -1;
        this.$bus.$on('loginSuccess', (data) => {
            this.isLogin = true;
            this.flag = data.flag;
            if (this.flag == 2) {
                this.reason = data.reason;
            }
            else if (this.flag == 5) {
                this.$router.push('/pc/submitInfo')
            }
            else if (this.flag == 1) {
                this.$router.push({ name: 'mediaservices' })
            }
        })
    },
    computed: {
        ...mapState(['isRed', 'userInfo']),
    },
    mounted() {
        this.getUserInfo();
    },
    methods: {
        changeNav(index) {
            this.navIndex = index
        },
        apply() {
            if (!this.isLogin) {
                this.$refs.login.open();
            }
            else if (this.flag == 5) {
                this.$router.push('/pc/submitInfo')
            }
            else if (this.flag == 1) {
                this.$router.push({ name: 'mediaservices' })
            }
        },
        getUserInfo() {
            this.$axios.post(this.$ApiInfo.getUserInfo, {},).then(data => {
                this.isLoding = false;
                this.$store.commit('setUserInfo', Object.assign(this.userInfo, data))
                this.flag = data.flag;
                if (this.flag == 2) {
                    this.reason = data.reason;
                }
                if (this.flag == 1) {
                    this.$router.push({ name: 'mediaservices' })
                }
            }).catch(err => {
                this.isLoding = false;
                if (err.status == 403) {
                    this.isLogin = false;
                    // this.$refs.login.open();
                }
            })
        },
        resetSubmit() {
            this.$router.push('/pc/submitInfo')
        },

    },
    watch: {

    }
}
</script>
<style lang="less">
.media-services-wrapper {
    background: #FAFAFA;
    // font-family: MicrosoftYaHei;
    text-align: center;
    padding: 0 81px;
    background: #FFFFFF;
    margin: 40px 0 80px;

    .box {
        color: #fff;
        padding: 120px 0;

        img {
            width: 80px;
            height: 80px;
        }

        p {
            color: #000;

            &.info-0 {
                font-weight: 500;
                font-size: 22px;
            }

            &.info-1 {
                margin: 20px 0 10px 0;
                color: rgb(231, 171, 119);
            }

            &.info-2 {
                margin: 0px 0 40px 0;
                color: #ccc;
            }
        }

        .info {
            margin: 50px 0;
        }

        .el-button {
            padding: 15px 60px;
            background-color: rgb(0, 108, 186) !important;
            border: none;
        }
    }
}

.icon-box {
    width: 80px;
    height: 80px;
}
</style>